export const Images = {
  realBricksLogo: require('../assets/images/RealBricksLogo.png'),
  accountCreated: require('../assets/images/account-created.png'),
  accountModal: require('../assets/images/account-modal.png'),
  addPaymentMethod: require('../assets/images/add-payment-method.png'),
  allSet: require('../assets/images/all-set.png'),
  deleteAccount: require('../assets/images/delete-account.png'),
  entityBuilding: require('../assets/images/entity-building.png'),
  selfDirectedIra: require('../assets/images/self-directed-ira.png'),
  error404: require('../assets/images/error404.png'),
  error505: require('../assets/images/error505.png'),
  faqArt: require('../assets/images/faq-art.png'),
  graphBlock: require('../assets/images/graph-block.png'),
  investmentAmount: require('../assets/images/investment-amount.png'),
  logout: require('../assets/images/log-out.png'),
  markethero: require('../assets/images/market-hero.png'),
  hero: require('../assets/images/hero.png'),
  openpopart: require('../assets/images/openpop-art.png'),
  openpopsecondary: require('../assets/images/open-pop-secondary.png'),
  portfoliochart: require('../assets/images/portfoliochart.png'),
  prop1: require('../assets/images/prop-01.jpg'),
  prop2: require('../assets/images/prop-02.jpg'),
  prop3: require('../assets/images/prop-03.jpg'),
  prop4: require('../assets/images/prop-04.jpg'),
  prop5: require('../assets/images/prop-05.jpg'),
  prop6: require('../assets/images/prop-06.jpg'),
  prop7: require('../assets/images/prop-07.jpg'),
  prop8: require('../assets/images/prop-08.jpg'),
  prop9: require('../assets/images/prop-09.jpg'),
  reactivate: require('../assets/images/reactivate.png'),
  resourceinvest: require('../assets/images/resource-invest.png'),
  resourcereturn: require('../assets/images/resource-return.png'),
  resourcereward: require('../assets/images/resource-reward.png'),
  resourcework: require('../assets/images/resource-work.png'),
  riskGraph: require('../assets/images/risk-graph.png'),
  smallGraph: require('../assets/images/small-graph.png'),
  success: require('../assets/images/success.png'),
  summaryGraphXS: require('../assets/images/summary-graph-xs.png'),
  summaryGraphSM: require('../assets/images/summary-graph-sm.png'),
  summaryGraphMD: require('../assets/images/summary-graph-md.png'),
  summaryGraphLG: require('../assets/images/summary-graph-lg.png'),
  summaryGraphXL: require('../assets/images/summary-graph-xl.png'),
  theleonardo: require('../assets/images/the-leonardo.jpg'),
  themartin: require('../assets/images/the-martin.jpg'),
  thewellington: require('../assets/images/the-wellington.jpg'),
  noPropertyFoundImage: require('../assets/images/noImageAvailable.png'),
  transfer: require('../assets/images/transfer.png'),
  home: require('../assets/images/home.png'),
  nofavorite: require('../assets/images/nofavorite.png'),
  portfoliozero: require('../assets/images/portfolio-zero.png'),
  affiliateIcon: require('../assets/images/affiliate-icon.svg')
};
